import styled, { css } from 'styled-components';
import { Card, Modal } from 'react-bootstrap';
import { MdOndemandVideo } from 'react-icons/md';

export const CustonDropdownItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  justify-content: flex-start;
  color: rgba(244, 241, 222, 0.8);
  white-space: nowrap;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-size: 13px;
  font-weight: 500;

  &:hover {
    color: #f4f1de;
    background: rgba(244, 241, 222, 0.1);
    transform: translateX(4px);
  }
`;

export const CustonDropdownIcon = styled(MdOndemandVideo)`
  margin-right: 10px;
  font-size: 16px;
  transition: all 0.3s ease;
`;

export const CustonDropdownText = styled.span`
  font-size: 13px;
  transition: all 0.3s ease;
`;

export const AccordionItem = styled(Card).withConfig({
  shouldForwardProp: (prop) => !['eventKey', 'activeKey'].includes(prop),
})`
  border: none;
  background: none;
  position: relative;
  z-index: 1;
`;

export const AccordionButton = styled(Card.Header)`
  padding: 0;
  border: none;
  background: none;
  position: relative;
  z-index: 1;
`;

export const AccordionBody = styled(Card.Body).withConfig({
  shouldForwardProp: (prop) => !['eventKey', 'activeKey'].includes(prop),
})`
  padding: 8px 0;
  background: none;
  margin-left: 20px;
  border-left: 2px solid rgba(244, 241, 222, 0.2);
  margin-top: 4px;
`;

export const CustomButton = styled.button`
  color: rgba(244, 241, 222, 0.8);
  background: transparent;
  border: 0;
  display: flex;
  width: 100%;
  text-align: left;
  padding: ${(props) => (props.isCollapsed ? '12px 8px' : '12px 16px')};
  border-radius: 12px;
  align-items: center;
  justify-content: ${(props) =>
      props.isCollapsed ? 'center' : 'flex-start'};
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
  font-weight: 500;
  font-size: 14px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(244, 241, 222, 0.05);
    border-radius: 12px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  svg {
    margin-right: ${(props) => (props.isCollapsed ? '0' : '12px')};
    font-size: 20px;
    transition: all 0.3s ease;
    position: relative;
    z-index: 2;
  }

  span {
    transition: all 0.3s ease;
    position: relative;
    z-index: 2;
  }

  ${({ isHovered }) =>
    isHovered &&
    css`
      color: #f4f1de;
      font-weight: 600;
      
      &::before {
        opacity: 1;
        background: rgba(244, 241, 222, 0.1);
      }
      
      svg {
        transform: scale(1.1);
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
      }
    `}

  &:hover {
    color: #f4f1de;
    font-weight: 600;
    
    &::before {
      opacity: 1;
      background: rgba(244, 241, 222, 0.1);
    }
    
    svg {
      transform: scale(1.1);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    }
  }

  @media (max-width: 768px) {
    padding: ${(props) => (props.isCollapsed ? '10px 6px' : '10px 14px')};
    
    svg {
      font-size: 18px;
    }
  }

  @media (max-width: 470px) {
    padding: ${(props) => (props.isCollapsed ? '8px 5px' : '8px 12px')};
    
    svg {
      font-size: 16px;
    }
  }
`;

export const StyledNav = styled.nav`
  display: flex;
  width: 100%;
`;

export const StyledUl = styled.ul`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: normal;
  gap: 8px;
  flex-direction: column;
  margin: ${(props) => (props.isCollapsed ? '10px 8px' : '15px 12px')};
  padding: 0;
  list-style: none;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    margin: ${(props) => (props.isCollapsed ? '8px 6px' : '12px 10px')};
    gap: 6px;
  }

  @media (max-width: 470px) {
    margin: ${(props) => (props.isCollapsed ? '6px 5px' : '10px 8px')};
    gap: 4px;
  }
`;

export const StyledModalHeader = styled(Modal.Header)`
  background: linear-gradient(90deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  border-bottom: 1px solid rgba(244, 241, 222, 0.2);
  color: #f4f1de;
  padding: 16px 20px;
  border-radius: 12px 12px 0 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 50%, rgba(244, 241, 222, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 50%, rgba(244, 241, 222, 0.05) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
    border-radius: 12px 12px 0 0;
  }
  
  .modal-title {
    color: #f4f1de;
    font-weight: 600;
    font-size: 18px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 1;
  }
  
  .btn-close {
    filter: invert(1) brightness(0.8);
    opacity: 0.8;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;
    
    &:hover {
      opacity: 1;
      transform: scale(1.1);
    }
  }
`;

export const StyledModalBody = styled(Modal.Body)`
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 20px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 80%, rgba(244, 241, 222, 0.05) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(244, 241, 222, 0.03) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }
  
  iframe {
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 1;
  }
`;

export const StyledModalFooter = styled(Modal.Footer)`
  background: linear-gradient(90deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  border-top: 1px solid rgba(244, 241, 222, 0.2);
  padding: 16px 20px;
  border-radius: 0 0 12px 12px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 50%, rgba(244, 241, 222, 0.05) 0%, transparent 50%),
      radial-gradient(circle at 80% 50%, rgba(244, 241, 222, 0.03) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
    border-radius: 0 0 12px 12px;
  }
  
  .btn {
    position: relative;
    z-index: 1;
    background: rgba(244, 241, 222, 0.1);
    border: 1px solid rgba(244, 241, 222, 0.2);
    color: #f4f1de;
    border-radius: 8px;
    padding: 8px 16px;
    font-weight: 500;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    
    &:hover {
      background: rgba(244, 241, 222, 0.2);
      border-color: rgba(244, 241, 222, 0.4);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
`;

export const StyledModal = styled(Modal)`
  .modal-content {
    background: transparent;
    border: none;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }
  
  .modal-dialog {
    max-width: 800px;
  }
`;

export const Separator = styled.div`
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(244, 241, 222, 0.3) 50%, transparent 100%);
  margin: 16px 8px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 4px;
    height: 4px;
    background: rgba(244, 241, 222, 0.5);
    border-radius: 50%;
  }
`;